import styled from "styled-components";

type StyledProps = {
  shareType: string;
};

export const EmailButtonStyled = styled.a<StyledProps>`
  cursor: pointer;
  svg {
    font-size: 22px;
    width: 25px;
  }
`;
